import React from 'react';
import SalespersonRequiredContainer from 'features/SalespersonRequired';

const SalespersonRequiredPage = () => <SalespersonRequiredContainer />;

export default SalespersonRequiredPage;
